import React, { useCallback, useEffect, useState } from 'react'
import OptionPresenter from '../api/optionPresenter'
import { Status } from '@iqueue/ui-kit'
import { t } from '../hooks/useTranslate'
import '../translations'

export default function ViewStatusNodes({ item, filed = false, currentValue }) {
  const [options, setOptions] = useState({})

  const handleGetOptions = useCallback(() => {
    OptionPresenter.get(`get-by-key/nodeStatuses`).then(setOptions).catch(res => console.error(res))
  }, [])

  useEffect(() => {
    handleGetOptions()
  }, [])

  return <Status
    warning={ options?.value?.warning.includes(item?.status) }
    error={ options?.value?.error.includes(item?.status) }
    inline={ !options?.value?.error.includes(item?.status) }
    className={ item?.nodeStatus && 'view-status-node' }
    weak
  >
    <b className={ filed ? 'status-information' : undefined }>
      { t(`status.node.${ currentValue || item.status || item?.nodeStatus }`) }
    </b>
  </Status>
}
